(function() {
    'use strict';

    angular.module('allegro').controller('AllegroSellerCreateController', AllegroSellerCreateController);

    AllegroSellerCreateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroSellersDataSrvc',
        'allegroSellerMessagesConst'
    ];

    function AllegroSellerCreateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroSellersDataSrvc,
        allegroSellerMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            tax_id: [],
            company_name: [],
            first_name: [],
            last_name: [],
            street: [],
            city: [],
            zip_code: [],
            logo: []
        };

        self.account = {};
        self.sellerData = {
            account: null,
            tax_id: '',
            company_name: '',
            first_name: '',
            last_name: '',
            street: '',
            city: '',
            zip_code: '',
            logo: null
        };

        self.getAccount = getAccount;
        self.createSeller = createSeller;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createSeller() {
            self.sellerData.account = self.account.pk;

            allegroSellersDataSrvc.create(self.sellerData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroSellerMessagesConst.add);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
